import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, Nav, NavItem, NavLink, Row } from "reactstrap";
import styled from "styled-components";
import { mediaQueries } from "./theme";
import Version from "./component/Version";

const Wrapper = styled.div`
  border-top: 3px solid rgba(255, 255, 255, 0.08);
  background-image: url("/allodedicace_image_de_fond_footer_mobile.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 0% 77%;
  margin-top: 30px;
  ${mediaQueries.desktop} {
    background-image: url("/allodedicace_image_de_fond_footer.png");
    background-position: 0% 85%;
  }
`;
const Icon = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  color: white;
  text-decoration: none;
`;

const Footer = () => {
  return (
    <Wrapper>
      <Container tag={"footer"} className={"text-white py-4 mt-5"} fluid>
        <Row>
          <Col className={"d-flex justify-content-center"}>
            <Nav
              className={"d-flex flex-column flex-lg-row align-items-center"}
            >
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/about-us"}
                  className={"text-white text-decoration-underline fs-6"}
                >
                  A propos
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/terms"}
                  className={"text-white text-decoration-underline fs-6"}
                >
                  Nos conditions
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/faq"}
                  className={"text-white text-decoration-underline fs-6"}
                >
                  FAQ
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={"/auth/sign-up"}
                  className={
                    "text-white text-center text-decoration-underline fs-6"
                  }
                >
                  Devenir une célébrité sur @llodedicace
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  href={"mailto:contact@allodedicace.com"}
                  className={"text-white text-decoration-underline fs-6"}
                >
                  Nous contacter
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <Row className={"pt-2"}>
          <Col className={"d-flex justify-content-center"}>
            <h5 className={"text-center"}>
              Suivez-nous sur les réseaux sociaux :
            </h5>
          </Col>
        </Row>
        <Row className={"pb-2"}>
          <Col className={"d-flex justify-content-center"}>
            <Icon
              href={"https://www.tiktok.com/@allodedicace"}
              target={"_blank"}
            >
              <i className="fa-brands fa-tiktok fs-4" color={"white"}></i>
              <span>tiktok</span>
            </Icon>
            <Icon
              href={"https://www.instagram.com/allodedicace/"}
              target={"_blank"}
            >
              <i className="fa-brands fa-instagram fs-4" color={"white"}></i>
              <span>instagram</span>
            </Icon>
            <Icon
              href={"https://www.facebook.com/allodedicace?locale=fr_FR"}
              target={"_blank"}
            >
              <i className="fa-brands fa-facebook fs-4" color={"white"}></i>
              <span>facebook</span>
            </Icon>
          </Col>
        </Row>
        <Row>
          <Col className={"d-flex justify-content-center border-top pt-2"}>
            © @llodedicace
          </Col>
        </Row>
        <Row>
          <Col className={"d-flex justify-content-end"}>
            <Version />
          </Col>
        </Row>
      </Container>
    </Wrapper>
  );
};

export default Footer;
